import commonCss from "PFApp/activities/show/activity_page/activity_page.module.scss";
import { useActivityShowContext } from "PFApp/activities/show/context/activity_show_context";
import { useActivityShortlists } from "PFApp/activities/show/hooks/use_activity_shortlists";
import { ProfilesListMode } from "PFApp/activities/types/profiles_view_mode";
import { useMemo } from "react";

import { ShortlistTableEntry } from "../../../activity_tabs.utils";
import { ShortlistEmptyState } from "./shortlist_empty_state";
import { ShortlistHeader } from "./shortlist_header";
import { useClearShortlist } from "./use_clear_shortlist";
import { ShortlistsCardsView } from "./views/shortlists_cards_view";
import { ShortlistsTableView } from "./views/shortlists_table_view";

export const ShortlistMainPanel = () => {
  const { profilesListMode } = useActivityShowContext();
  const { allShortlists, rankedShortlists, isLoadingShortlists } = useActivityShortlists();
  const { handleClearShortlist, isLoading: isClearShortlistLoading } = useClearShortlist();

  const isLoading = isLoadingShortlists || isClearShortlistLoading;
  const noResults = !isLoading && !allShortlists.length;

  const shortlistsEntries = useMemo(
    () =>
      allShortlists.map<ShortlistTableEntry>((shortlist) => {
        const match = (rankedShortlists || []).find(
          (rankedShortlist) => rankedShortlist.profile.id === shortlist.profile.id
        );

        return {
          match,
          shortlist
        };
      }),
    [allShortlists, rankedShortlists]
  );

  const ShortlistDataComponent =
    profilesListMode === ProfilesListMode.Cards ? ShortlistsCardsView : ShortlistsTableView;

  return (
    <div className={commonCss.pageCardMainPanel}>
      <ShortlistHeader handleClearShortlist={handleClearShortlist} />
      {noResults ? (
        <ShortlistEmptyState />
      ) : (
        <ShortlistDataComponent shortlistsEntries={shortlistsEntries} isLoading={isLoading} />
      )}
    </div>
  );
};
